import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { findDoc } from '../FormalityDocs'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LegalFormalityDocumentContext } from 'contexts/LegalFormalityDocumentContext'
import {
  DocumentTypesListWrapper,
  FormalityColorError,
  FormalityColorSuccess,
  Tag,
} from '../styles'
import {
  CheckCircleTwoTone,
  ClockCircleTwoTone,
  CloseCircleTwoTone,
  ExclamationCircleTwoTone,
} from '@ant-design/icons'
import { documentListItemType } from 'types'
import { toDotSeparated } from '../FormalityDocs'

const TypesList = () => {
  const { t } = useTranslation()
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const {
    sortedDocumentList,
    setSelectedDocumentListItem,
    setCurrentDocument,
  } = useContext(LegalFormalityDocumentContext)

  const documentTagIcon = (documentListItem: documentListItemType) => {
    const doc = findDoc(legalFormality.documents, documentListItem)

    switch (doc && doc.state) {
      case 'pending':
        return (
          <ClockCircleTwoTone
            style={{ color: 'orange' }}
            twoToneColor={'orange'}
          />
        )
      case 'in_error':
        return (
          <CloseCircleTwoTone
            style={{ color: `${FormalityColorError}` }}
            twoToneColor={`${FormalityColorError}`}
          />
        )
      case 'validated':
        return (
          <CheckCircleTwoTone
            style={{ color: `${FormalityColorSuccess}` }}
            twoToneColor={`${FormalityColorSuccess}`}
          />
        )
      default:
        return (
          <ExclamationCircleTwoTone
            style={{ color: 'blue' }}
            twoToneColor={'blue'}
          />
        )
    }
  }

  const handleSelectDocument = (documentListItem: documentListItemType) => {
    setSelectedDocumentListItem(documentListItem)
    setCurrentDocument(findDoc(legalFormality.documents, documentListItem))
  }
  return (
    <DocumentTypesListWrapper>
      {sortedDocumentList &&
        sortedDocumentList.map((documentListItem: documentListItemType) => {
          const { documentType, required } = documentListItem
          const key = `${documentType}${
            documentListItem.target &&
            `_${documentListItem.target.type}_${documentListItem.target.id}`
          }_tag`
          const targetLabel =
            documentListItem.target &&
            documentListItem.target?.label &&
            `: ${documentListItem.target.label || ''}`
          const tagsDisplay =
            documentListItem.tags && documentListItem.tags.join(' - ')
          const label = ` 
            ${t(
              `legalFormalities:document_types.${toDotSeparated(documentType)}`
            )}
            ${required ? ' *' : ''}
            ${targetLabel ? ` ${targetLabel}` : ''}
            ${tagsDisplay ? ` (${tagsDisplay})` : ''}
          `
          return (
            <Tag
              key={key}
              type="primary"
              onClick={() => {
                handleSelectDocument(documentListItem)
              }}
            >
              {documentTagIcon(documentListItem)}
              {label}
            </Tag>
          )
        })}
    </DocumentTypesListWrapper>
  )
}

export default TypesList
